/** 사이드바 메뉴 SVG 아이콘 — 골드 실루엣 스타일 (24×24) */
const G = 'url(#bg-side-nav-gold)'
const S = 'url(#bg-side-nav-gold-soft)'

export const SIDE_MENU_ICON_PATHS = {
  mypage: [
    { d: 'M12 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M12 10.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5z', fill: G },
    { d: 'M7.25 18.75c.55-2.65 2.65-4.25 4.75-4.25s4.2 1.6 4.75 4.25', fill: G }
  ],
  deposit: [
    { d: 'M12 3.25c-3.45 0-6.25 2.55-6.25 5.7 0 3.85 2.75 6.2 6.25 9.05 3.5-2.85 6.25-5.2 6.25-9.05 0-3.15-2.8-5.7-6.25-5.7z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M12 8.5v6.75M8.75 11.875h6.5', stroke: G, strokeWidth: 1.75, strokeLinecap: 'round' }
  ],
  withdraw: [
    { d: 'M12 3.25c-3.45 0-6.25 2.55-6.25 5.7 0 3.85 2.75 6.2 6.25 9.05 3.5-2.85 6.25-5.2 6.25-9.05 0-3.15-2.8-5.7-6.25-5.7z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M12 15.25V8.5M9.25 11.125 12 8.375l2.75 2.75', stroke: G, strokeWidth: 1.75, strokeLinecap: 'round', strokeLinejoin: 'round' }
  ],
  event: [
    { d: 'M5.5 10.5h13a1.25 1.25 0 0 1 1.25 1.25v7.5a1.25 1.25 0 0 1-1.25 1.25h-13A1.25 1.25 0 0 1 4.25 19.25v-7.5A1.25 1.25 0 0 1 5.5 10.5z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M4.75 10.5h14.5M12 20.25V10.5', stroke: G, strokeWidth: 1.1 },
    { d: 'M12 10.5C10.2 7.55 7.75 6.25 7.75 6.25S9.95 7.8 12 10.5zM12 10.5c1.8-2.95 4.25-4.25 4.25-4.25S14.05 7.8 12 10.5z', fill: G }
  ],
  notice: [
    { d: 'M6.75 5.25h10.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5H6.75a1.5 1.5 0 0 1-1.5-1.5V6.75a1.5 1.5 0 0 1 1.5-1.5z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M8.75 9.25h6.5M8.75 12.25h6.5M8.75 15.25h4.25', stroke: G, strokeWidth: 1.55, strokeLinecap: 'round' },
    { d: 'M17.25 8.25l2.25 1.35v4.8l-2.25 1.35V8.25z', fill: G }
  ],
  support: [
    { d: 'M12 3.75a5.25 5.25 0 0 0-5.25 5.25v2.25c0 1.35.55 2.55 1.45 3.45L7.5 18.75h9l-.7-4.05c.9-.9 1.45-2.1 1.45-3.45V9A5.25 5.25 0 0 0 12 3.75z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M9.25 18.75v1.25a2.75 2.75 0 0 0 5.5 0v-1.25', stroke: G, strokeWidth: 1.35, strokeLinecap: 'round' },
    { d: 'M5.25 10.5v1.1a1.6 1.6 0 0 0 1.6 1.6h.65M18.75 10.5v1.1a1.6 1.6 0 0 1-1.6 1.6h-.65', stroke: G, strokeWidth: 1.35, strokeLinecap: 'round' }
  ],
  slip: [
    { d: 'M5.25 6.75h13.5a1.25 1.25 0 0 1 1.25 1.25v11a1.25 1.25 0 0 1-1.25 1.25H5.25A1.25 1.25 0 0 1 4 18.75v-11a1.25 1.25 0 0 1 1.25-1.25z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M8.25 11.25h7.5M8.25 14.25h5.25', stroke: G, strokeWidth: 1.55, strokeLinecap: 'round' },
    { d: 'M16.75 6.75V5.5a1.25 1.25 0 0 0-1.25-1.25H8.5A1.25 1.25 0 0 0 7.25 5.5v1.25', stroke: G, strokeWidth: 1.1 },
    { d: 'M15.75 16.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z', fill: G }
  ],
  betting: [
    { d: 'M7.25 4.75h9.5a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-9.5a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M9.25 4.75V3.75a2.25 2.25 0 0 1 2.25-2.25h1a2.25 2.25 0 0 1 2.25 2.25v1', stroke: G, strokeWidth: 1.1 },
    { d: 'M8.75 13.25l2.1 2.1 4.65-4.65', stroke: G, strokeWidth: 1.65, strokeLinecap: 'round', strokeLinejoin: 'round' },
    { d: 'M8.75 9.25h2.25M13 9.25h2.25', stroke: G, strokeWidth: 1.35, strokeLinecap: 'round', opacity: 0.55 }
  ],
  attendance: [
    { d: 'M6.75 5.25h10.5a1.5 1.5 0 0 1 1.5 1.5v11.25a1.5 1.5 0 0 1-1.5 1.5H6.75a1.5 1.5 0 0 1-1.5-1.5V6.75a1.5 1.5 0 0 1 1.5-1.5z', fill: S, stroke: G, strokeWidth: 1.1 },
    { d: 'M8.25 4.25V3.75a3.75 3.75 0 0 1 7.5 0v.5', stroke: G, strokeWidth: 1.1, strokeLinecap: 'round' },
    { d: 'M6.75 10.25h10.5M8.25 13.75h2.25M13.5 13.75h2.25M8.25 17.25h2.25M13.5 17.25h2.25', stroke: G, strokeWidth: 1.35, strokeLinecap: 'round' },
    { d: 'M16.75 8.75l1.75 1.05v2.95L16.75 13.8V8.75z', fill: G }
  ]
}

export function getSideMenuIconPaths (icon) {
  return SIDE_MENU_ICON_PATHS[icon] || SIDE_MENU_ICON_PATHS.mypage
}
